/**
 * Given URLSearchParam, remove a key or a value from key array
 */
const removeURLParam = (
  params: URLSearchParams,
  key: string,
  valueToRemove?: string
) => {
  if (!valueToRemove) {
    // Remove all entries of the key
    params.delete(key);
  } else {
    // Get all entries of the key
    const values = params.getAll(key);
    if (values.length) {
      // Delete them all
      params.delete(key);
      // Then iterate over the stored values and append all except the removed value
      for (const value of values) {
        if (value !== valueToRemove) {
          params.append(key, value);
        }
      }
    }
  }

  return params;
};

export { removeURLParam };
